// @ts-ignore https://contrast.atlassian.net/browse/SCA-1396
import { vanillaUserAndOrganizationStore, vanillaSplitClient } from '../state'
import type { RbacStatus } from '../types/rbac'

export const getRbacStatus = (): RbacStatus => {
  const { currentOrganization } = vanillaUserAndOrganizationStore.getState()
  const { isSplitTreatmentOn } = vanillaSplitClient.getState()

  // New RBAC flags
  const rbacServiceEnabled = isSplitTreatmentOn('PROD-2415-rbac_service_enabled')
  const rbacServiceEnforceScan = isSplitTreatmentOn('PROD-2415-rbac_service_enforce_scan')
  const rbacServiceEnforceAssess = isSplitTreatmentOn('PROD-2415-rbac_service_enforce_assess')

  const isSastEnabled = currentOrganization.isSastEnabled
  const notFreemium = !currentOrganization.isFreemium

  // Only return true if the org has sast enabled and the accompanying rbac flag is enabled
  const rbacServiceEnforceScanEnabled = isSastEnabled && rbacServiceEnforceScan

  if (notFreemium) {
    return {
      enabled: rbacServiceEnabled,
      isEnforced: rbacServiceEnforceScanEnabled || rbacServiceEnforceAssess,
      splitFlag: isSastEnabled
        ? 'PROD-2415-rbac_service_enforce_scan'
        : 'PROD-2415-rbac_service_enforce_assess',
      isScanEnforced: rbacServiceEnforceScanEnabled,
      isAssessEnforced: rbacServiceEnforceAssess
    }
  } else {
    return {
      enabled: false,
      isEnforced: false,
      splitFlag: '',
      isScanEnforced: false,
      isAssessEnforced: false
    }
  }
}
